import { react2angular } from 'react2angular';
import app from '../../../browser/addform/scripts/app';
import { withContext } from '../../utils/hoc/withContext';
import { LoadingOverlay } from './LoadingOverlay';

app.component('loadingOverlay', react2angular(withContext(LoadingOverlay), [], ['config']));
